import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-apollo";
import { toast } from "react-toastify";
import { ALL_VEHICLES_VIEW_BY_PAGE_QUERY } from "../../../graphql/Vehicles/Vehicles.graphql";

import DataTable from "../../../components/DataTable";
import PageHeader from "../../../components/PageHeader";
import { VehicleColumns } from "./columns";

import "./Vehicles.scss";
import { getFilterState, saveFilterState } from "../../../utils";
import { ALL_SYSTEM_CODES_QUERY } from "../../../graphql/SystemCodes/SystemCodes.graphql";

import VehicleFilters from "./VehicleFilters";

import { useAuthorization } from "../../../components/Authorization";

const VehiclesPage = () => {
  const isAuthed = useAuthorization(["FLEET", "ADMIN", "FIN"]);
  const { data } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category: "Fleet",
        CodeName: "VehicleStatus"
      }
    }
  });

  const DispatcherAuth = useAuthorization(["DISP"]);
  const isDispatcher = DispatcherAuth && !isAuthed;

  const INITIAL_FILTER_STATE = getFilterState("VEHICLE_FILTERS", {});
  const [filters, setFilters] = useState({ ...INITIAL_FILTER_STATE });
  const history = useHistory();

  useEffect(() => {
    const systemCodes = data?.SystemCodes;
    if (Array.isArray(systemCodes)) {
      setFilters(prev => ({
        ...prev,
        StatusRecIdRef_in: systemCodes
          .filter(x => !["Terminated", "Inactive"].includes(x.CodeDescription))
          .map(x => x.RecId)
      }));
    }
  }, [data]);

  const handleSetFilters = inputs => {
    // Clearing filters if is empty and avoid null response from query
    Object.keys(inputs).forEach(
      key =>
        (!inputs[key] ||
          inputs[key] === 0 ||
          inputs[key] === "" ||
          inputs[key].length === 0) &&
        delete inputs[key]
    );
    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    if (Filters.Vehicle) {
      delete Filters.Vehicle;
      Filters.RecId = parseInt(Filters.RecId);
    }
    if (Filters.VehicleTypeRecIdRef) {
      Filters.VehicleTypeRecIdRef = parseInt(Filters.VehicleTypeRecIdRef);
    }
    setFilters({
      ...Filters
    });
    saveFilterState("VEHICLE_FILTERS", Filters);
  };

  const resetFilters = () =>
    handleSetFilters({
      StatusRecIdRef_in: [null, ...data?.SystemCodes.map(s => s.RecId)].filter(
        Boolean
      )
    });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={VehicleFilters}
        columns={VehicleColumns(() => {}, true, false)}
        filters={filters}
        name="VW_VehiclesByPage"
        query={ALL_VEHICLES_VIEW_BY_PAGE_QUERY}
        readOnly={isDispatcher}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Vehicles"
        onAddClick={() =>
          isAuthed
            ? history.push("/fleet/vehicles/new")
            : toast.warning("You don't have permission to add a vehicle.")
        }
      />
      <DataTable
        isPaginated
        columns={VehicleColumns(() => {}, true, false)}
        dataQuery={ALL_VEHICLES_VIEW_BY_PAGE_QUERY}
        initialSortBy={[
          {
            id: "VehicleNumber",
            desc: false
          }
        ]}
        name="VW_VehiclesByPage"
        where={filters}
        onRowClick={({ RecId }) =>
          history.push(`/fleet/vehicles/${RecId}/profile`)
        }
      />
    </React.Fragment>
  );
};

VehiclesPage.propTypes = {};
export default VehiclesPage;
